import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Network } from '@capacitor/network';
import { Toast } from '@capacitor/toast';
import { BehaviorSubject, lastValueFrom } from 'rxjs';

export interface CheckConnectionResponse {
  success: boolean;
  message: string;
}




export type ConnectionType = 'wifi' | 'cellular' | 'none' | 'unknown';

@Injectable({
  providedIn: 'root',
})
export class NetworkService {
  connected$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  connectionType$: BehaviorSubject<ConnectionType> = new BehaviorSubject<ConnectionType>('unknown');
  constructor(private http: HttpClient) { }


  observerNetWork() {
    Network.addListener('networkStatusChange', (status) => {
      this.connected$.next(status.connected);
      this.connectionType$.next((status.connectionType as ConnectionType) ?? 'unknown');
    });

    this.getCurrentNetWorkStatus();
  }

  async getCurrentNetWorkStatus() {
    const status = await Network.getStatus();
    this.connected$.next(status.connected);
    this.connectionType$.next((status.connectionType as ConnectionType) ?? 'unknown');
  }

  getConnectionType(): ConnectionType {
    return this.connectionType$.value ?? 'unknown';
  }

  esCellular(): boolean {
    return this.getConnectionType() === 'cellular';
  }

  async showMessage(value: boolean) {
    if (value) {
      await Toast.show({
        text: 'Conectado a la red',
        duration: 'short',
        position: 'bottom',
      });
    } else {
      await Toast.show({
        text: 'Desconectado de la red',
        duration: 'short',
        position: 'bottom',
      });
    }
  }


  async checkServerConnection(): Promise<boolean> {
    try {
      const api = '/check-connection'
      const response = await lastValueFrom(this.http.get<CheckConnectionResponse>(api, { responseType: 'json' }));
      return response.success;
    } catch (error) {
      return false;
    }
  }
}
